import {
  createHashRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useRouteError,
  Routes,
} from "react-router-dom";
import Login, { loginLoader } from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import History from "./Pages/History";
import Reservations from "./Pages/Reservations";
import Settings from "./Pages/Settings";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./Theme/theme";
import CssBaseline from "@mui/material/CssBaseline";
import styles from "./index.css";
import { Provider } from "react-redux";
import store from "./Redux/Store/store";
import ActiveCalls from "./Pages/ActiveCalls";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import Helper from "./Pages/Helper";
import { I18nextProvider } from "react-i18next";
import i18n from "./Translation/i18n";
import { withTranslation } from "react-i18next";
import { useEffect, useState } from "react";

function App() {
  //3) Functions
  const routes = createRoutesFromElements(
    <>
      <Route
        path="/"
        element={<Login />}
        errorElement={<ErrorBoundary />}
        loader={loginLoader}
      />
      <Route
        path="Login"
        index
        element={<Login />}
        loader={loginLoader}
        errorElement={<ErrorBoundary />}
      />
      <Route path="/Dashboard" element={<Dashboard />} />
      <Route path="/History" element={<History />} />
      <Route path="/Reservations" element={<Reservations />} />
      <Route path="/Settings" element={<Settings />} />
      <Route path="/Active Calls" element={<ActiveCalls />} />
      <Route path="/Helper" element={<Helper />} />
    </>
  );
  const router = createHashRouter(routes, { basename: "/" });
  let persistor = persistStore(store);

  return (
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <CssBaseline />
              <div className="app">
                <main className="content">
                  <RouterProvider router={router} />
                </main>
              </div>
            </PersistGate>
          </Provider>
        </LocalizationProvider>
      </I18nextProvider>
    </ThemeProvider>
  );
}

function ErrorBoundary() {
  let error = useRouteError();
  console.error(error);
  // Uncaught ReferenceError: path is not defined
  return (
    <div>
      <h1>Error</h1>
    </div>
  );
}

export default withTranslation()(App);
